import { gql } from "@apollo/client";

export const AddItemLdgrAssociByItem = gql`
  mutation AddItemLdgrAssociByItem(
    $token: String!
    $customer_id: ID!
    $user_details: SubscribedUser!
    $itemId: ID!
    $ldgrIds: [ID!]!
  ) {
    AddItemLdgrAssociByItem(
      token: $token
      customer_id: $customer_id
      user_details: $user_details
      itemId: $itemId
      ldgrIds: $ldgrIds
    )
  }
`;

export const DeleteItemLdgrAssociByItem = gql`
  mutation DeleteItemLdgrAssociByItem(
    $token: String!
    $customer_id: ID!
    $user_details: SubscribedUser!
    $itemId: ID!
    $ldgrIds: [ID!]!
  ) {
    DeleteItemLdgrAssociByItem(
      token: $token
      customer_id: $customer_id
      user_details: $user_details
      itemId: $itemId
      ldgrIds: $ldgrIds
    )
  }
`;
